export const AUTH_URL = process.env.REACT_APP_POINT_AUTH || "http://localhost/api/auth";
export const AGENT_URL = process.env.REACT_APP_POINT_AGENT || "http://localhost/api/agent";
export const RECORD_URL = process.env.REACT_APP_POINT_REC || "http://localhost/api/records";
